class Estado {
  constructor(dados) {
    this.id = dados.id;
    this.nome = dados.nome;
    this.sigla = dados.sigla;
    this.codigoIbge = dados.codigoIbge;
    this.idPais = dados.idPais;
  }
}
export default Estado;
